import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchDocumentForm, createDocumentForm, updateDocumentForm } from './actions';
import DocumentFormSettingsForm from './SettingsForm';
import authUtils from '../../auth/utils';
import { Panel } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

class Details extends Component {
	constructor(props) {
		super(props);
		this.handleDocumentFormSettingsSubmit = this.handleDocumentFormSettingsSubmit.bind(this);
	}

	componentDidMount() {
		const { match, fetchDocumentForm } = this.props;
		const documentFormId = match.params.id;
		if (documentFormId) {
			fetchDocumentForm(documentFormId);
		}
	}

	handleDocumentFormSettingsSubmit(values) {
		const { documentForm, createDocumentForm, updateDocumentForm, history } = this.props;

		if (documentForm) {
			updateDocumentForm(documentForm.id, values);
		} else {
			createDocumentForm(values, history);
		}
	}

	render() {
		const { documentForm, isReadonly, documentCategories, t } = this.props;
		return <Panel>
			<Panel.Heading>{t('Common_Details')}</Panel.Heading>
			<Panel.Body>
				<DocumentFormSettingsForm isReadonly={isReadonly} onSubmit={this.handleDocumentFormSettingsSubmit} initialValues={documentForm} documentCategories={documentCategories} />
			</Panel.Body>
		</Panel>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const documentFormId = ownProps.match.params.id;

	const {
		entities: { documentForms },
		auth: { currentUser },
		lookups
	} = state;

	return {
		documentForm: documentForms[documentFormId],
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'DocumentForm'),
		documentCategories: lookups.documentCategories
	};
};

const mapDispatchToProps = {
	fetchDocumentForm,
	createDocumentForm,
	updateDocumentForm
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Details));